module.exports = __webpack_public_path__ + "static/img/LOGO_quan@2x.9f1c3bea.png";